<template>
  <div class="basic-info">
    <div class="basic-info__list">
      <div class="basic-info__item">
        <div class="basic-info__wrap">
          <div class="basic-info__icon">
            <img src="@/assets/mendianzongshu.png" alt="icon">
          </div>
          <div class="basic-info__data">
            <div class="basic-info__label">门店数量</div>
            <div class="basic-info__value">{{dataLoaded ? jianYaoData.menDianShuLiang : 0}}</div>
          </div>
        </div>
      </div>

      <div class="basic-info__item">
        <div class="basic-info__wrap">
          <div class="basic-info__icon">
            <img src="@/assets/faxianyinhuan.png" alt="icon">
          </div>
          <div class="basic-info__data">
            <div class="basic-info__label">发现隐患</div>
            <div class="basic-info__value">{{dataLoaded ? jianYaoData.yinHuanShuLiang : 0}}</div>
          </div>
        </div>
      </div>

      <div class="basic-info__item">
        <div class="basic-info__wrap">
          <div class="basic-info__icon">
            <img src="@/assets/zhenggaishuliang.png" alt="icon">
          </div>
          <div class="basic-info__data">
            <div class="basic-info__label">整改数量</div>
            <div class="basic-info__value">{{dataLoaded ? jianYaoData.zhengGaiShuLiang : 0}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/util/request.js'

export default {
  data () {
    return {
      timer: null,
      dataLoaded: false,
      jianYaoData: null
    }
  },
  created () {
    this.getJianYao()
  },
  methods: {
    async getJianYao () {
      const res = await request.get('/common/jian-yao')
      this.jianYaoData = res.data
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getJianYao()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.basic-info {

}

.basic-info__list {
  display: flex;
}

.basic-info__item {
  flex: 1;

  &:not(:last-child) {
    margin-right: 16px;
  }
}

.basic-info__wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  color: #6c92ef;
  background-color: #153896;
}

.basic-info__icon {
  margin-right: 16px;

  img {
    height: 46px;
  }
}
</style>
